import React from 'react';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';

export default function PopupRemoveService(props) {
    return (
        <div className='remove-service-popup'>
            <div className='popup-title'>
                האם להסיר את {props.selectedService?.selfCareCmsData?.title}?
            </div>
            <div className='popup-description'>
                לא חבל? לאחר ההסרה אי אפשר יהיה להשתמש בשירות
            </div>
            <div className='popup-button-wrapper'>
                <BtnSubmit isBusiness={false} text='הסרה' onclick={props.onServiceRemove} formid='service-details-popup' isDisplayArrows={false} />
            </div>
            <div className='popup-link-wrapper'>
                <a href='#' onClick={(e) => { props.onCencelClick(e) }}>לא, לחצתי בטעות</a>
            </div>
        </div>
    );
};

